import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom, map } from 'rxjs';
import { DeviceInfoService } from '../../../shared/services/device-info.service';

@Injectable({
  providedIn: 'root',
})
export class RosterShiftsService {
  constructor(
    private http: HttpClient,
    private deviceInfoService: DeviceInfoService,
  ) {}

  getRosterShifts(params?: any) {
    return this.http
      .get(`/api/roster_shift/`, { params: params })
      .pipe(map((response: any) => response));
  }

  async updateRosterShifts(id: string, body?: any, params?: any) {
    body = {
      ...body,
      device_info: await this.deviceInfoService.getDeviceDetail(),
    };
    return lastValueFrom(
      this.http
        .put(`/api/roster_shift/${id}/`, body, { params: params })
        .pipe(map((response: any) => response)),
    );
  }

  async getCondtionalRosteredJobs(params?: any) {
    return lastValueFrom(
      this.http
        .get(`/api/roster_shift/conditional_rostered_jobs/`, {
          params: params,
        })
        .pipe(map((response: any) => response)),
    );
  }

  async managePatrolRoute(body: any, params?: any) {
    body = {
      ...body,
      device_info: await this.deviceInfoService.getDeviceDetail(),
    };
    return lastValueFrom(
      this.http
        .post(`/api/roster_shift/manage_patrol_route/`, body, {
          params: params,
        })
        .pipe(map((response: any) => response)),
    );
  }
  getPatrolRoute(body: any, params?: any) {
    return this.http
      .post(`/api/roster_shift/get_patrol_route_detail/`, body, {
        params: params,
      })
      .pipe(map((response: any) => response));
  }

  getRosterData(params?: any) {
    return this.http
      .get(`/api/roster_shift/get_roster_data/`, { params: params })
      .pipe(map((response: any) => response));
  }
  publishRosterData(body?: any, params?: any) {
    return this.http
      .post(`/api/roster_shift/publish_shifts/`, body, { params: params })
      .pipe(map((response: any) => response));
  }
  async updateShifts(body?: any, params?: any) {
    body = {
      ...body,
      device_info: await this.deviceInfoService.getDeviceDetail(),
    };
    return lastValueFrom(
      this.http
        .post(`/api/roster_shift/update_shifts/`, body, { params: params })
        .pipe(map((response: any) => response)),
    );
  }
}
